import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './RangeInput.css'
import InputSlider from 'react-input-slider';
import Textfield from './Textfield';


export default function RangeInput(props) {
    const [state, setState] = useState(props.min);
    useEffect(() => {
        props.onChange(state);
    }, [state])
    return (
        <div className='input-container'>
            <div className='input-header'>
                <div
                    className='label fs-small fw-medium clr-primary-heading'>
                    {props.label}
                </div>

                <Textfield
                    className='textfield-wrapper'
                    leading={props.leading}
                    trailing={props.trailing}
                    min={props.min}
                    max={props.max}
                    tfValue={state}
                    onChange={(value) => {
                        setState(parseInt(value))
                    }}
                    onError = {(e)=>{
                        props.onError(e);
                    }}
                />
            </div>

            <InputSlider
                className='input-slider'
                xmax={props.max}
                xmin={props.min}
                axis="x"
                x={state}
                onChange={({ x }) => {
                    setState(x);

                }}
                styles={{
                    track: {
                        height: '0.25rem',
                        borderRadius: '6.25rem',
                        background: '#E9E9E9',

                    },
                    active: {
                        borderRadius: '6.25rem',
                        background: 'linear-gradient(107deg, #BA62FF 0%, #AA42FC 40%, #7241FF 100%)',
                    },
                    thumb: {
                        width: '1.3125rem',
                        height: '1.3125rem',
                        borderRadius: '6.25rem',
                        border: '0.4px solid #CACACA',
                        background: '#FAFAFA',
                        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.12)',
                    },
                    disabled: {
                        opacity: 0.5
                    }
                }}
            />

        </div>
    )
}

// const InputRange = ({ min, max, step, value, onChange }) => {
//   const [dragging, setDragging] = useState(false);

//   const handleChange = (e) => {
//     onChange(parseFloat(e.target.value));
//   };

//   const handleDragStart = () => {
//     setDragging(true);
//   };

//   const handleDragEnd = () => {
//     setDragging(false);
//   };

//   return (
//     <div style={{ width: '300px', margin: '20px' }}>
//       <input
//         type="range"
//         min={min}
//         max={max}
//         step={step}
//         value={value}
//         onChange={handleChange}
//         style={{
//           width: '100%',
//           cursor: 'pointer',
//           pointerEvents: dragging ? 'none' : 'auto',
//         }}
//       />
//       <motion.div
//         style={{
//           width: '100%',
//           height: '10px',
//           background: 'lightblue',
//           position: 'relative',
//         }}
//         animate={{
//           width: `${((value - min) / (max - min)) * 100}%`,
//         }}
//       >
//         <motion.div
//           style={{
//             width: '10px',
//             height: '10px',
//             borderRadius: '50%',
//             background: 'blue',
//             position: 'absolute',
//             top: 0,
//             left: '50%',
//             transform: 'translateX(-50%)',
//           }}
//           drag="x"
//           dragConstraints={{ left: 0, right: '100%' }}
//           dragElastic={false}
//           onDragStart={handleDragStart}
//           onDragEnd={handleDragEnd}
//         />
//       </motion.div>
//       <div style={{ marginTop: '10px' }}>Value: {value}</div>
//     </div>
//   );
// };

// export default InputRange;